export enum PostStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum PostModerationReasons {
  SPAM = "spam",
  OFF_TOPIC = "off_topic",
  PERSONAL_DATA = "personal_data",
  SAFETY = "safety",
  HATE_ABUSE = "hate_abuse",
  ILLEGAL = "illegal",
  SCAM_FRAUD = "scam_fraud",
  NSFW = "nsfw",
  DUPLICATE = "duplicate",
  LOCATION_SENSITIVE = "location_sensitive",
  OTHER = "other",
}

export interface Author {
  id: string;
  name: string | null;
  email?: string | null;
}

export interface Comment {
  id: string;
  content: string;
  status: string;
  author: Author;
  parentId: string | null;
  replies: Comment[];
  created_at: string;
}

export interface Post {
  id: string;
  title: string;
  content: string;
  status: string;
  communityId: string;
  author: Author;
  created_at: string;
  comments: Comment[];
  likeCount: number;
  isLiked: boolean;
  photos?: string[];
  tags: string[];
  languages: string[];
  source_language?: string;
  translations?: Record<
    string,
    {
      title: string;
      content: string;
    }
  >;
  image_captions?: Array<{
    image_index: number;
    translations: Partial<Record<string, string>>;
  }>;
}

export interface IPostData {
  id: string;
  title: string;
  content: string;
  author: {
    id: string;
    name: string;
    email: string;
  };
  status: string;
  created_at: string;
  likeCount: number;
  commentCount: number;
}

export interface ReportedPostData {
  id: string;
  post_id: string;
  post_title: string;
  post_content: string;
  community_id: string;
  posted_by: {
    id: string;
    name: string;
    email: string;
    is_deleted: boolean;
    user_type: string;
  };
  reported_by: {
    id: string;
    name: string;
    email: string;
    is_deleted: boolean;
    user_type: string;
  };
  reason: string;
  reported_at: string;
  status: string;
}

export interface IReportedPostData {
  id: string;
  post_id: string;
  title: string;
  content: string;
  community_id: string;
  author: {
    id: string;
    name: string;
    email: string;
  };
  reported_by: {
    id: string;
    name: string;
    email: string;
  };
  reportReason: string;
  reported_at: string;
  status: string;
}

export interface PaginatedPostResponse {
  posts: Post[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface ReportedPostResponse {
  data: ReportedPostData[];
  total_items: number;
  current_page: number;
  page_limit: number;
  total_pages: number;
}
